module.exports = __webpack_public_path__ + "media/components/country-flag/static/pa-060dac25d6b648fe27864771e4baecea.svg";